// Source unique de la locale courante de l'app, dérivée d'i18n (donc du préfixe d'URL).
//
// Context-independent à dessein : utilisable depuis un `utils/` appelé hors d'un setup
// (ex. `mediaUploadApi.ts`) là où `useI18n()` lèverait. `tryUseNuxtApp()` est scoppé à la
// requête en SSR (pas de contamination inter-requêtes) et renvoie `null` hors contexte
// Nuxt → on retombe sur la locale par défaut.
//
// Une seule locale aujourd'hui ⇒ valeur constante `"fr"`. Quand le multi-locale arrivera,
// cette fonction reflètera automatiquement la locale i18n active sans changement d'appelant.
const DEFAULT_LOCALE = "fr";

export function appLocale(): string {
  return tryUseNuxtApp()?.$i18n?.locale?.value ?? DEFAULT_LOCALE;
}
